module.exports = __webpack_public_path__ + "img/house.9235cf8b.jpeg";